import swalState from "../../utility/swal";
import { message } from "antd";
import PayoutAPI from "../../services/payouts";

export const PAYOUT_ACTION_TYPES = {
    SET_PAYOUT_LIST: "SET_PAYOUT_LIST",
    CLEAR_PAYOUT_LIST: "CLEAR_PAYOUT_LIST",
    SET_PAYOUT_LOADING: "SET_PAYOUT_LOADING",
    SET_PAYOUT_ERROR: "SET_PAYOUT_ERROR",
    ADD_PAYOUT_SUCCESS: "ADD_PAYOUT_SUCCESS",
    SET_ADD_PAYOUT_LOADING: "SET_ADD_PAYOUT_LOADING",
};

export function setPayoutList(payload) {
    return {
        type: PAYOUT_ACTION_TYPES.SET_PAYOUT_LIST,
        payload,
    };
}

export function clearPayoutList() {
    return {
        type: PAYOUT_ACTION_TYPES.CLEAR_PAYOUT_LIST,
    };
}

export function setPayoutLoading(loading) {
    return {
        type: PAYOUT_ACTION_TYPES.SET_PAYOUT_LOADING,
        payload: loading,
    };
}

export function setPayoutError(error) {
    return {
        type: PAYOUT_ACTION_TYPES.SET_PAYOUT_ERROR,
        payload: error,
    };
}

export function setAddPayoutLoading(loading) {
    return {
        type: PAYOUT_ACTION_TYPES.SET_ADD_PAYOUT_LOADING,
        payload: loading,
    };
}

export function addPayoutSuccess(payload) {
    return {
        type: PAYOUT_ACTION_TYPES.ADD_PAYOUT_SUCCESS,
        payload,
    };
}


export const getPayoutList = (rideId) => async (dispatch) => {
    if (!rideId) {
        const errorMsg = "RideId is required to fetch payout list";
        console.error(errorMsg);
        dispatch(setPayoutError(errorMsg));
        return { success: false, error: errorMsg };
    }

    try {
        dispatch(setPayoutLoading(true));
        dispatch(setPayoutError(null));
        swalState.showLoader();
        console.log("Fetching payout list for rideId:", rideId);

        const response = await PayoutAPI.getPayoutList(rideId);

        if (response && (response.data || response.success)) {
            const payoutData = response.data || response;
            console.log("Payout list response:", payoutData);

            dispatch(setPayoutList(payoutData));
            return { success: true, data: payoutData };
        } else {
            console.log("No payout data found for ride:", rideId);
            dispatch(setPayoutList({
                totalPayout: 0,
                paidPayout: 0,
                payoutHistory: []
            }));
            return { success: true, data: {} };
        }
    } catch (err) {
        const errorMsg = err.response?.data?.message || err.message || "Failed to fetch payout list";
        console.error("Error fetching payout list:", err);

        dispatch(setPayoutError(errorMsg));
        message.error(errorMsg);

        dispatch(setPayoutList({
            totalPayout: 0,
            paidPayout: 0,
            payoutHistory: []
        }));

        return { success: false, error: errorMsg };
    } finally {
        dispatch(setPayoutLoading(false));
        swalState.hideLoader();
    }
};


export const addPayout = (rideId, payoutData) => {
    return async (dispatch, getState) => {

        if (!rideId) {
            const error = "RideId is required to add payout";
            console.error(error);
            message.error(error);
            return { success: false, error };
        }

        if (!payoutData) {
            const error = "Payout data is required";
            console.error(error);
            message.error(error);
            return { success: false, error };
        }

        try {
            dispatch(setPayoutLoading(true));
            dispatch(setPayoutError(null));

            swalState.showLoader();

            console.log("Action creator received:");
            console.log("- rideId:", rideId);
            console.log("- payoutData:", payoutData);

            const requiredFields = ['paidAmount', 'payoutMode', 'payoutOrderId'];
            for (const field of requiredFields) {
                if (!payoutData[field]) {
                    throw new Error(`${field} is required`);
                }
            }

            const apiPayload = {
                productId: payoutData.productId || rideId,
                productType: payoutData.productType || "RIDES",
                paidAmount: payoutData.paidAmount.toString(),
                payoutMode: payoutData.payoutMode,
                payoutStatus: payoutData.payoutStatus || "SUCCESS",
                payoutOrderId: payoutData.payoutOrderId,
                message: payoutData.message || "Payment processed",
                ...(payoutData.paymentDate && { paymentDate: payoutData.paymentDate }),
                ...(payoutData.userId && { userId: payoutData.userId }),
            };

            console.log("Final API Payload:", apiPayload);
            console.log("payoutUserId in payload:", apiPayload.payoutUserId);

            const response = await PayoutAPI.addPayout(apiPayload);

            if (response && (response.success !== false)) {
                console.log("Payout added successfully:", response);
                await dispatch(getPayoutList(rideId));

                return { success: true, data: response.data || response };
            } else {
                const errorMsg = response?.message || response?.error || "Failed to add payout";
                throw new Error(errorMsg);
            }
        } catch (error) {
            console.error("Add payout error:", error);

            const errorMsg = error.response?.data?.message ||
                error.message ||
                "Failed to add payout";

            dispatch(setPayoutError(errorMsg));

            return { success: false, error: errorMsg };
        } finally {
            dispatch(setPayoutLoading(false));
            swalState.hideLoader();
        }
    };
}

export const refreshPayoutData = (rideId) => async (dispatch) => {
    if (rideId) {
        return await dispatch(getPayoutList(rideId));
    }
    return { success: false, error: "No rideId provided" };
};

export const clearPayoutError = () => (dispatch) => {
    dispatch(setPayoutError(null));
};